var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "moon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.967,13.9508c-1.523,0.154-3.15-0.042-4.845-0.775 c-2.362-1.022-4.276-2.936-5.298-5.298c-0.732-1.695-0.929-3.321-0.775-4.845c0.081-0.792-0.733-1.354-1.447-1.005 c-3.614,1.773-6.003,5.654-5.546,10.044c0.482,4.625,4.247,8.391,8.872,8.872c4.391,0.457,8.272-1.932,10.044-5.546 C22.322,14.6838,21.759,13.8698,20.967,13.9508 M12.999,18.9998c-0.284,0-0.573-0.015-0.864-0.045 c-3.66-0.381-6.708-3.429-7.09-7.09c-0.292-2.804,0.85-5.449,2.979-7.125c0.087,1.331,0.41,2.648,0.964,3.931 c1.217,2.815,3.529,5.126,6.341,6.341c1.278,0.553,2.598,0.877,3.931,0.964C17.764,17.8738,15.487,18.9998,12.999,18.9998"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.dbb784ee.svg";
export { ForwardRef as ReactComponent };